
{
  "placeholder": "Search for your location",
  "errors": {
    "no-location-address": "No location address associated with that location"
  }
}
